const SESSION_AUTH_DATA = "SESSION_AUTH_DATA";
export const useSessionAuthData = () => {
    const saveRegisterData = (formValues) => {
        sessionStorage.setItem(SESSION_AUTH_DATA, JSON.stringify(formValues));
    };
    const getRegisterData = () => {
        const data = sessionStorage.getItem(SESSION_AUTH_DATA);
        if (data) {
            try {
                return JSON.parse(data);
            }
            catch (error) {
                console.error("Cannot parse SESSION_AUTH_DATA", error);
            }
        }
        return null;
    };
    const clearRegisterData = () => {
        sessionStorage.removeItem(SESSION_AUTH_DATA);
    };
    return {
        saveRegisterData,
        getRegisterData,
        clearRegisterData,
    };
};
